$(->
  # ADMIN > EDIT ACCOUNT

  ## Show/hide Snagajob settings on check
  $('#account_snagajob_feed_enabled').click ->
    $('#snagajob_settings').toggleClass('hidden')

  ## Change help text subdomain as user types
  domain_span = $('#account_subdomain_input .help-block span.domain')
  $('.subdomain_wrapper input').keyup( ->
    $(this).parent().find('.help-block span.subdomain').text($(this).val())
  )

  ## Change help text subdomain if user changes optional domain
  $('#account_domain_id').change(->
    if $(this).val() != ''
      domain_span.text($(this).find('option:selected').text())
    else
      domain_span.text(domain_span.data('orig-value'))
  )
  domain_span.data('orig-value', $('#account_subdomain_input .help-block span.domain').text())
  $('#account_domain_id').trigger('change')
)
